<ion-content #modal>
    <div class="sub-body">
        <div class="team-name" #teamName>
            <span [ngStyle]="{
                backgroundColor: team?.colors[0]
              }">
               {{ team?.name }}
            </span>
        </div>
        <div #mainPlayer class="active-player {{match.matchType === 'S' ? 'singles-match' : ''}}">
            <div class="ion-text-center title">Select Active Player</div>
            <app-sub-player 
                [player]="player?.activePlayer" 
                [tie]="tie" 
                [team]="team" 
                [sideNumber]="sideNumber"
                (playerSelectedId)="activePlayerSelected($event)"
                [matchType]="match?.matchType">
            </app-sub-player>
        </div>

       @if(activePlayerId && isChecked){
            <div class="ion-text-center title" #subSelect>Select Sub</div>

            <div class="scrollable-sub" [style.height.px]="rowHeight">
                <app-sub-player 
                    [player]="player?.subPlayer" 
                    [tie]="tie" 
                    [team]="team" 
                    [sideNumber]="sideNumber"
                    (playerSelectedId)="subPlayerSelected($event)">
                </app-sub-player>
            </div>
        }
    </div>
</ion-content>
<ion-footer #footer>
    <ion-buttons class="timeout-btns">
        <ion-button color="dark" class="undo-btn" (click)="dismiss()">CLOSE</ion-button>
        <ion-button 
            [disabled]="(!activePlayerId && !isChecked) || !subPlayerInfo?._id" 
            color="light" 
            class="end-btn" 
            expand="block" 
            (click)="updatePlayer()">
            SUB
        </ion-button>
    </ion-buttons>
</ion-footer>


